var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M21.585 16.312c-2.52-1.29-5.79-2.34-9.585-2.34-3.795 0-7.065 1.05-9.585 2.34A4.455 4.455 0 0 0 0 20.302v4.17h24v-4.17c0-1.68-.915-3.225-2.415-3.99zM21 21.472H3v-1.17c0-.57.3-1.08.78-1.32 1.785-.915 4.665-2.01 8.22-2.01 3.555 0 6.435 1.095 8.22 2.01.48.24.78.75.78 1.32v1.17zm-12.33-9h6.66a2.99 2.99 0 0 0 2.97-3.39l-.48-3.675A5.896 5.896 0 0 0 12 .472a5.896 5.896 0 0 0-5.82 4.935L5.7 9.082a2.99 2.99 0 0 0 2.97 3.39zm.48-6.615A2.884 2.884 0 0 1 12 3.472c1.41 0 2.61 1.005 2.85 2.385l.48 3.615H8.67l.48-3.615z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a2065d471ec88731e3de970cfc75922e.svg";
export { ForwardRef as ReactComponent };